import { __exports as r } from "./contact-channels240.js";
import { __require as v } from "./contact-channels241.js";
var f;
function j() {
  if (f) return r;
  f = 1;
  var o = r && r.__importDefault || function(e) {
    return e && e.__esModule ? e : { default: e };
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.default = l;
  var _ = o(v());
  function l(e, n) {
    var t = null;
    if (!e || typeof e != "string")
      return t;
    var s = (0, _.default)(e), p = typeof n == "function";
    return s.forEach(function(u) {
      if (u.type === "declaration") {
        var a = u.property, i = u.value;
        p ? n(a, i, u) : i && (t = t || {}, t[a] = i);
      }
    }), t;
  }
  return r;
}
export {
  j as __require
};
//# sourceMappingURL=contact-channels236.js.map
